import { createSelector } from 'reselect';
import { IAppState } from '../reducers';

export const selectRootState = (state: IAppState) => state.modals;

export const selectRocketModal = createSelector(selectRootState, (modals) => modals && modals.rocket);

export const selectDownloadSuccessModal = createSelector(selectRootState, (modals) => modals && modals.downloadSuccess);

export const selectLowInventoryModal = createSelector(selectRootState, (modals) => modals && modals.lowInventoryItems);

export const selectRemovePIIModal = createSelector(selectRootState, (modals) => modals && modals.removePII);

export const selectPortalsWarningModal = createSelector(selectRootState, (modals) => {
  return modals && modals.portalsWarning;
});
